module.exports = __webpack_public_path__ + "img/main-bg.d314005.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ad/main-bg.png
// module id = dM1f
// module chunks = 2